import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";

const ResetPasswordStep = ({ onSuccess, back }) => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const submit = () => {
    if (!password || password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    onSuccess();
  };

  return (
    <>
      {error && <Alert variant="danger">{error}</Alert>}

      <Form.Group className="mb-3">
        <Form.Label>New Password</Form.Label>
        <div className="position-relative">
          <Form.Control
            type={showPassword ? "text" : "password"}
            className="form-input"
            placeholder="Enter new password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="btn-icon-show"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#999",
            }}
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </button>
        </div>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Confirm Password</Form.Label>
        <div className="position-relative">
          <Form.Control
            type={showConfirmPassword ? "text" : "password"}
            className="form-input"
            placeholder="Confirm password"
            onChange={(e) => setConfirm(e.target.value)}
          />
          <button
            type="button"
            className="btn-icon-show"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#999",
            }}
          >
            {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
          </button>
        </div>
      </Form.Group>

      <div className="hstack gap-2">
        <Button className="w-100 btn-secondary" onClick={back}>
          Back
        </Button>
        <Button className="w-100 btn-primary" onClick={submit}>
          Update Password
        </Button>
      </div>
    </>
  );
};

export default ResetPasswordStep;
